import { render, staticRenderFns } from "./view-settings-dialog.vue?vue&type=template&id=bcf743b4"
import script from "./view-settings-dialog.vue?vue&type=script&lang=js"
export * from "./view-settings-dialog.vue?vue&type=script&lang=js"
import style0 from "./view-settings-dialog.vue?vue&type=style&index=0&id=bcf743b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports